import { rest, RestError } from '@/lib/rest';
import type { User } from '@/types/firebase';
import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';

export const useAuthAccountsStore = defineStore('authAccountsStore', () => {
  const accounts: Ref<User[]> = ref([]);

  async function loadAccounts() {
    if (!accounts.value.length) {
      accounts.value = (await rest.get('/auth/accounts').send<User[]>()) || [];
    }
    return accounts.value;
  }

  async function check() {
    try {
      await loadAccounts();
    } catch (err) {
      // An expired or missing session returns 401 here. Treat that as "not
      // logged in" so the router guard redirects to login rather than letting
      // the error escape the guard and leave a blank page.
      if (err instanceof RestError && err.code === 401) return false;
      throw err;
    }
    return accounts.value.length > 0;
  }

  return { accounts, check };
});
